<p-announcement-management-view class="dock-y"></p-announcement-management-view>
